<template>
  <slot />
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      addAddressForm: null,
      addAddressCancel: null,
      addAddressTrigger: null,
      editTriggers: []
    }
  },
  mounted () {
    this.setElems()
    this.eventListeners()
  },
  methods: {
    setElems () {
      this.addAddressTrigger = document.querySelector('.addresses__add-cta')
      this.addAddressCancel = document.querySelector('.address-form__cancel')
      this.addAddressForm = document.querySelector('.addresses__form-wrapper')

      this.editTriggers = [...document.querySelectorAll('[data-edit-address-cta]')]
    },
    eventListeners () {
      this.addAddressTrigger.addEventListener('click', () => {
        this.addAddressForm.classList.remove('hidden')
        this.addAddressTrigger.scrollIntoView({ behavior: "smooth" })
      })
      this.addAddressCancel.addEventListener('click', () => {
        this.addAddressForm.classList.add('hidden')
        window.scrollTo(0, 0)
      })

      this.editTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          console.log('show edit address form')
        })
      })
    }
  },
}
</script>
